import React from 'react';

import styles from './styles.module.scss';
import {AntiWebhookCard} from '../../../components/Cards/AntiWebhookCard';
import {AntiRaidCard} from '../../../components/Cards/AntiRaidCard';
import {AntiNukeCard} from '../../../components/Cards/AntiNukeCard';
import {VerificationCard} from '../../../components/Cards/VerificationCard';
import {AntiSpamCard} from '../../../components/Cards/AntiSpamCard';
import {FakeDetectionCard} from '../../../components/Cards/FakeDetectionCard';

export const Cards = () => {
  return (
    <div className={styles.cards}>
      <div className={styles.container}>
        <h3 className={styles.title}>
          Protect your <span className={styles.decor}>community</span> with{' '}
          <span className={styles.decor}>advanced features</span> and{' '}
          <span className={styles.decor}>ML-driven</span> security, in end-to-end encrypted space.
        </h3>
        <ul className={styles.cardsWrapper}>
          <li>
            <AntiWebhookCard />
          </li>
          <li>
            <VerificationCard />
          </li>
          <li>
            <AntiSpamCard />
          </li>
          <li>
            <AntiRaidCard />
          </li>
          <li>
            <FakeDetectionCard />
          </li>
          <li>
            <AntiNukeCard />
          </li>
        </ul>
      </div>
    </div>
  );
};
